var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-video"},[(_vm.hasVideo)?[_c('video',{attrs:{"playsinline":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.computedVideoSource.url,"type":_vm.computedVideoSource.mime}})])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }